import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import DataService from "features/Application/services/dataServices/typedDataService";
import { getPrefix } from "../../../../Application/slices/models";

export const fetchGroupEnrollmentCompanyNames = createAsyncThunk<string[], number>(
  getPrefix({
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.Groups,
    name: "enrollmentCompanies",
  }),
  async (accountId: number) => {
    const result = await DataService.accounts.getCompanyNames(accountId);
    return result.data;
  },
);
